import "./single-satellite-high-resolutions.scss";
import "../../../js/core";
import "../../../components/site-elements/other-blocks/collapse-tabs/collapse-tabs";
import Collapse from "bootstrap/js/src/collapse";

import "sticky-kit/dist/sticky-kit";

jQuery(function ($) {
  const $sticky = $(".section-collapse-tabs .image-wrap");

  if ($(window).width() >= 992 && $sticky.length) {
    $sticky.stick_in_parent({
      offset_top: 92,
      parent: ".collapse-tabs",
    });

    $sticky.on("sticky_kit:stick", function () {
      const $el = $(this);

      $el.addClass("is_stuck");

      $el.css({
        transform: "translateY(20px)",
        opacity: 0.95,
      });

      requestAnimationFrame(() => {
        $el.css({
          transform: "translateY(0)",
          opacity: 1,
        });
      });
    });

    $sticky.on("sticky_kit:unstick", function () {
      $(this).removeClass("is_stuck").css({
        transform: "",
        opacity: "",
      });
    });
  }
});

// tooltip
document.addEventListener("DOMContentLoaded", function () {
  const tooltipIcons = document.querySelectorAll(".tooltip-icon");

  tooltipIcons.forEach(function (el) {
    const tooltipText = el.getAttribute("data-tooltip");
    const tooltipContent = document.createElement("div");
    tooltipContent.className = "tooltip-content";
    tooltipContent.innerHTML = tooltipText;

    const closeBtn = document.createElement("span");
    closeBtn.className = "tooltip-close";
    closeBtn.innerHTML = "×";
    tooltipContent.appendChild(closeBtn);

    el.appendChild(tooltipContent);

    el.addEventListener("click", function (e) {
      e.stopPropagation();
      el.classList.toggle("tooltip-active");
    });

    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      el.classList.remove("tooltip-active");
    });
  });
});
